export default "__VITE_ASSET__012245fc__"